import { axiosInstance } from "../axios";

export const nhaCungCapApi = {
  getAll: async (params) => {
    return await axiosInstance.get("/suppliers", { params });
  },
  getById: (id) => axiosInstance.get(`/suppliers/${id}`),
};
